import { apiFetch } from '@/api'
import { Wholesaler } from '@/interfaces'

export const fetchAllWholesalers = async (): Promise<Wholesaler> =>
  (await apiFetch('/wholesalers', { method: 'GET' })).data
